module.exports = __webpack_public_path__ + "static/media/onespan.b5de6304.jpeg";